import axios from "axios";







const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
    (request) => {
        
        let edexLicenceToken = localStorage.getItem("edexLicenceToken");
        let lang = localStorage.getItem("lang")

        if (edexLicenceToken) {
            request.headers.Authorization = `Bearer ${edexLicenceToken}`;
        }

        request.headers["Accept-Language"] = lang;

        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);



export default axiosInstance;
